import ReportIcon from '@/views/report-center/component/report-icon/report-icon.vue'
import { inject } from 'vue'

export interface IconMap {
  'material-detail'?: string;
  'material-summay'?: string;
}

const reportIconKey = Symbol()

const reportIconMap: IconMap = {}

const componentPlugin = {
  install(vue) {
    const ctx = require.context('@/assets/report-icon', false, /\.png$/)
    ctx.keys().forEach((path) => {
      const temp = path.match(/\.\/([A-Za-z0-9\-_]+)\.png$/)
      if (!temp) return
      const name = temp[1]
      if (process.env.isVite) {
        reportIconMap[name] = new URL(`/src/assets/report-icon/${name}.png`, import.meta.url).href;
      } else {
        reportIconMap[name] = require(`@/assets/report-icon/${name}.png`);
      }
    })

    vue.provide(reportIconKey, reportIconMap)
    vue.component(ReportIcon.name, ReportIcon)
  }
}

export function useReportCenterIcon()  {
  return inject<IconMap>(reportIconKey)
}

export default componentPlugin
